import { render, staticRenderFns } from "./coupon-add.vue?vue&type=template&id=4808dd72&"
import script from "./coupon-add.vue?vue&type=script&lang=js&"
export * from "./coupon-add.vue?vue&type=script&lang=js&"
import style0 from "./coupon-add.vue?vue&type=style&index=0&id=4808dd72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports